import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-form-company-select"
export default class extends Controller {
  connect(): void {
    this.setSelectCompany();
  }

  // コントローラーをアタッチしている外側に配置した hidden #job_content_company_code の値を取得して、その値を持つラジオボタンをチェックする
  setSelectCompany(): void {
    const companyCodeElement = document.getElementById('job_content_company_code') as HTMLInputElement | null;

    if (companyCodeElement) {
      const companyCode = companyCodeElement.value;
      const radioButton = document.querySelector(`input[type="radio"][value="${companyCode}"]`) as HTMLInputElement | null;
      if (radioButton) {
        radioButton.checked = true;
      }
    }
  }

  // コントローラーをアタッチしている外側に配置した hidden #job_content_company_code の値を更新する
  changeCompany({ params }: { params: { companyCode: string }}): void {
    const companyCode = params.companyCode;

    const companyCodeElement = document.getElementById('job_content_company_code') as HTMLInputElement | null;
    if (companyCodeElement) {
      companyCodeElement.value = companyCode;
    }
  }
}
